"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var flattenPlacements_1 = require("./flattenPlacements");
function getAllMediaKeys(mediumGroups) {
    return Object.keys(_.groupBy(flattenPlacements_1.flattenPlacements(mediumGroups), function (placement) {
        return placement["medium"]["key"];
    }));
}
exports.getAllMediaKeys = getAllMediaKeys;
//# sourceMappingURL=getAllMediaKeys.js.map


//////////////////
// WEBPACK FOOTER
// ./buildForProduction/datalayer/posterControllerSupportingClasses/getAllMediaKeys.js
// module id = 63
// module chunks = 0